var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#03A4F0;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.6,342.6h51.8l54.7,133.5h2.3l54.7-133.5H301v198.7h-40.8V412h-1.6l-51.4,128.4h-27.7L128,411.5h-1.6v129.8 H85.6V342.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.5,399.7c-0.8-7.8-4.1-13.9-10-18.2c-5.9-4.3-13.9-6.5-24-6.5c-6.9,0-12.6,1-17.4,2.9 c-4.7,1.9-8.3,4.5-10.8,7.9c-2.5,3.4-3.7,7.2-3.7,11.4c-0.1,3.6,0.6,6.7,2.3,9.3c1.6,2.7,3.9,4.9,6.8,6.8c2.9,1.9,6.3,3.6,10.1,4.9 c3.8,1.4,7.9,2.6,12.2,3.5l17.9,4.3c8.7,1.9,16.6,4.5,23.9,7.8c7.2,3.2,13.5,7.2,18.8,11.9c5.3,4.7,9.4,10.3,12.4,16.7 c2.9,6.4,4.4,13.7,4.5,22c-0.1,12.2-3.2,22.7-9.3,31.6c-6.1,8.9-14.9,15.8-26.4,20.7c-11.5,4.9-25.3,7.3-41.5,7.3 c-16,0-30-2.5-41.9-7.4c-11.9-4.9-21.1-12.2-27.7-21.9c-6.6-9.7-10.1-21.7-10.4-35.9H360c0.5,6.7,2.4,12.2,5.8,16.6 c3.4,4.4,8,7.8,13.7,10c5.7,2.2,12.2,3.3,19.5,3.3c7.1,0,13.3-1,18.6-3.1c5.3-2.1,9.4-4.9,12.3-8.6c2.9-3.7,4.4-7.9,4.4-12.7 c0-4.5-1.3-8.2-3.9-11.3c-2.6-3-6.4-5.6-11.4-7.8c-5-2.1-11.1-4.1-18.4-5.8l-21.6-5.4c-16.8-4.1-30-10.4-39.7-19.1 c-9.7-8.7-14.5-20.3-14.5-35c-0.1-12,3.2-22.5,9.7-31.5c6.5-9,15.4-16,26.8-21.1c11.4-5,24.3-7.6,38.8-7.6 c14.7,0,27.6,2.5,38.7,7.6c11,5,19.6,12.1,25.8,21.1c6.1,9,9.3,19.4,9.5,31.2H433.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M494.8,541.3V342.6h131.6v34.6h-89.6v47.3h80.8v34.6h-80.8v82.1H494.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M637.2,377.2v-34.6h163.2v34.6h-60.8v164.1H698V377.2H637.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsftIcon);
export default __webpack_public_path__ + "static/media/msft_icon.ba1488cbcb5b9d3a1ced9208860822ee.svg";
export { ForwardRef as ReactComponent };